<template>
  <div class="main-log">
    <q-page class="column justify-center items-center" style="min-height: auto">
      <verifyOTP
        v-if="iti"
        @close="(e) => (verifyOtp = e)"
        :deviceLimitToken="deviceLimitToken"
        :verifyOtp="verifyOtp"
        :phoneNumber="phoneNumber"
        :countryCode="countryCode"
        :iti="iti"
      ></verifyOTP>
      <q-card class="q-my-lg">
        <q-card-section style="padding: 50px">
          <div class="row no-wrap items-center">
            <div class="col text-h6 ellipsis">
              <span
                :style="
                  (this,
                  $q.dark.mode ? { color: '#FFF' } : { color: ' #102b7b' })
                "
                >Welcome to</span
              >
              <span style="color: #61ce70"> Chukul!</span>
            </div>
          </div>
          <div
            v-if="routeName !== 'Dashboard'"
            class="text-caption text-purple q-pl-xs"
          >
            Please Login to access {{ routeName }}
          </div>
        </q-card-section>
        <q-card-section style="padding: 40px; padding-top: 0px">
          <q-form class="q-gutter-md" @submit="onSubmit">
            <q-input
              filled
              v-model="phoneNumber"
              for="phone"
              :label-color="this.$q.dark.mode ? 'white' : 'black'"
              lazy-rules
              :rules="[
                (val) =>
                  (val && val.length > 0) || 'Please type your phone number',
              ]"
            >
              <!-- <template v-slot:prepend>
                <q-icon name="phone" />
              </template> -->
            </q-input>
            <!-- <q-input
              v-model="phoneNumber"
              type="tel"
              for="phone"
              filled
              error-message="Please type your Phone Number"
            /> -->

            <q-input
              :type="isPwd ? 'password' : 'text'"
              filled
              v-model="password"
              label="Password"
              lazy-rules
              :rules="[
                (val) => (val && val.length > 0) || 'Please type your password',
              ]"
            >
              <template v-slot:prepend>
                <q-icon name="password" />
              </template>
              <template v-slot:append>
                <q-icon
                  :name="isPwd ? 'visibility_off' : 'visibility'"
                  class="cursor-pointer"
                  @click="isPwd = !isPwd"
                />
              </template>
            </q-input>
            <div class="bottom">
              <q-btn
                :disable="loggingIn"
                :label="!loggingIn ? 'Login' : 'Logging in'"
                type="submit"
                color="positive"
                style="width: 100%"
              />
            </div>

            <p class="text-weight-medium text-center">
              <router-link
                to="/reset"
                style="text-decoration: none; color: #61ce70"
                >Forgot password?
              </router-link>
            </p>
          </q-form>
          <q-separator />
          <div class="q-mt-md text-center text-black">
            Don't have an account?
            <q-btn
              flat
              no-caps
              color="primary"
              label="Sign Up"
              :to="{
                name: 'Signup',
              }"
            />
          </div>
        </q-card-section>
      </q-card>
    </q-page>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { LocalStorage } from "quasar";
import { useQuasar } from "quasar";
import useMembership from "src/use/membership";
import verifyOTP from "src/components/verifyOtp.vue";
import { required, minLength, sameAs } from "@vuelidate/validators";
// import { useVuelidate } from "@vuelidate/core";
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";
import "intl-tel-input/build/js/utils";

export default {
  name: "AuthLogin",
  components: {
    verifyOTP,
  },

  setup() {
    const $q = useQuasar();
    const $router = useRouter();
    const route = useRoute();
    const { getPackageStatus } = useMembership();
    const countryCode = ref("");
    const loggingIn = ref(false);

    // const step1Rules = {
    //   phoneNumber: { required },
    // };
    const iti = ref("");
    const step1State = reactive({
      phoneNumber: "",
    });
    onMounted(() => {
      const input = document.querySelector("#phone");

      iti.value = intlTelInput(input, {
        initialCountry: "np",
        customPlaceholder: () => "Phone Number",
      });
    });
    // const v1$ = useVuelidate(step1Rules, step1State, { $lazy: true });

    const routeName = ref("");
    const signalName = ref("");
    routeName.value = route.query.route ? route.query.route : "Dashboard";
    signalName.value = route.query.signal ? route.query.signal : "";

    const $store = useStore();
    const phoneNumber = ref("");
    const password = ref("");
    const isPwd = ref(true);
    const verifyOtp = ref(false);
    const deviceLimitToken = ref("");
    const onSubmit = (evt) => {
      loggingIn.value = true;
      $store
        .dispatch("authenticate/login", {
          username: phoneNumber.value,
          password: password.value,
          device: process.env?.IS_CAPACITOR
            ? process.env?.IS_ANDROID
              ? "android"
              : "ios"
            : "web",
          medium: "chukul",
          hostname: $store.state.domain.domain,
          sweta: $store.state.domain.sweta,
          prabhu: $store.state.domain.prabhu,
          arthasarokar: $store.state.domain.arthasarokar,
          globalimecapital: $store.state.domain.globalimecapital,
        })
        .then(() => {
          $router.push({
            name: routeName.value,
            query: signalName.value
              ? {
                  signal: signalName.value,
                }
              : "",
          });
          $q.notify({
            type: "positive",
            message: "Login Successful",
          });
          // turn off chukul pack
        })
        .catch((error) => {
          loggingIn.value = false;
          const { data, status } = error.response;
          countryCode.value = "+" + iti.value.selectedCountryData.dialCode;
          if (status === 412) {
            verifyOtp.value = true;
            deviceLimitToken.value = data.token;
          }
          const message = data
            ? data.message
            : "incorrect mobile number or password";

          $q.notify({
            type: "negative",
            message: message,
            timeout: 15000,
            textColor: "white",
            actions: [{ icon: "close", color: "white" }],
          });
        });
    };

    return {
      // v1$,
      loggingIn,
      iti,
      countryCode,
      deviceLimitToken,
      verifyOtp,
      slide: ref("style"),
      phoneNumber,
      password,
      isPwd,
      onSubmit,
      routeName,
    };
  },
};
</script>
<style>
.blur-background {
  filter: blur(5px);
}
</style>
